import routes from './routes';
import { SetRoutes } from 'components';

const KpiWeekdaysHolidaysPages = () => {
  return (
    <>
      <SetRoutes routes={routes} />
    </>
  );
};

export default KpiWeekdaysHolidaysPages;
